import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

interface Promo {
  eyebrow: string;
  title: string;
  body: string;
  ctaLabel: string;
  ctaHref: string;
  media: string;
  mediaType: 'image' | 'video';
  accent: string;
}

@Component({
  selector: 'app-ads-showcase-section',
  templateUrl: './ads-showcase-section.component.html',
  styleUrl: './ads-showcase-section.component.scss',
  standalone: true,
  imports: [CommonModule, MatIconModule],
})
export class AdsShowcaseSectionComponent {
  promos: Promo[] = [
    {
      eyebrow: 'In focus',
      title: 'Record every decision. Never lose a minute.',
      body:
        'Automatic recording, searchable transcripts, and shareable highlights — so the people who missed the meeting never miss the point.',
      ctaLabel: 'See recordings in action',
      ctaHref: '/features/recordings',
      media: 'assets/videos/video1.mp4',
      mediaType: 'video',
      accent: '#14BBEE',
    },
    {
      eyebrow: 'Partner spotlight',
      title: 'Trusted infrastructure, powered by eGA.',
      body:
        'Hosted on sovereign cloud, backed by Tanzania\'s e-Government Authority. Enterprise-grade security without the enterprise price tag.',
      ctaLabel: 'Learn about our platform',
      ctaHref: '/about',
      media: 'assets/images/artboard2.png',
      mediaType: 'image',
      accent: '#5BDFA2',
    },
    {
      eyebrow: 'New',
      title: 'Reserve rooms as easily as you join calls.',
      body:
        'Our reservation engine handles conference rooms, auditoriums, and shared resources across every branch — one calendar, zero conflicts.',
      ctaLabel: 'Explore reservations',
      ctaHref: '/features/reservations',
      media: 'assets/videos/video2.mp4',
      mediaType: 'video',
      accent: '#0E97C1',
    },
  ];

  isEven(i: number) {
    return i % 2 === 0;
  }
}
